import React from 'react';
import {  useParams } from 'react-router-dom';
import { formatMessage } from '../../../../locale';
import {
  ListContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from './PersonalList.style';
import { useLazyExportMyCourseProgressQuery } from '../../../../slices/dashboardApiSlice';
import { Button } from '../../../../ui-kit';
import { RiskHeader } from '../../Dashboard.styles';
import { useMedia } from '../../../../ui-kit/utils/media';

export const SurveyList = ({ data }: any) => {
  const [personalProgress] = useLazyExportMyCourseProgressQuery();
  const { isMobile } = useMedia();

  const handleExport = async () => {
    try {
        const blob = await personalProgress({}).unwrap(); 
        if (blob) {
            const url = URL.createObjectURL(blob); 
            const a = document.createElement('a'); 
            a.href = url;
            a.download = 'my_results.xlsx'; 
            document.body.appendChild(a);
            a.click(); 
            document.body.removeChild(a); 
            URL.revokeObjectURL(url);
        }
    } catch (error) {
        console.error('Error exporting team results:', error);
    }
};

  
  return (
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', cursor: 'normal', padding: 20, backgroundColor: 'white', marginBottom: 100, borderRadius: '10px', border: '1px solid rgba(234, 231, 242, 1)',  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
            <RiskHeader isMobile={isMobile}>
              <h2 style={{ display: 'flex', flexWrap: 'wrap', fontSize: '1.5rem', marginBottom: 20 }}>
              {formatMessage({ id: 'dashboardCourse.courseTracker', defaultMessage: 'Course Tracker' })}
              </h2>
              <Button
                  appearance='primary'
                  onClick={() => {handleExport()}}
                >
                {formatMessage({ id: 'dashboardCourse.exportToExcel', defaultMessage: 'Export to Excel' })}
                </Button>
            </RiskHeader>
              <ListContainer>
            <Table>
              <Thead>
                <Tr>
                  <Th>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.assignedCourse', defaultMessage: 'Assigned course' })}
                  </Th>
                  <Th style={{ textAlign: 'center' }}>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.assignedDate', defaultMessage: 'Assigned date' })}
                  </Th>                
                  <Th>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.completed', defaultMessage: 'Completed' })}
                  </Th>      
                  <Th style={{ textAlign: 'center' }}>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.attemptToComplete', defaultMessage: 'Attempt to complete' })}
                  </Th>
                  <Th style={{ textAlign: 'center' }}>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.dateCompleted', defaultMessage: 'Date completed' })}
                  </Th>
                  <Th style={{ textAlign: 'center' }}>
                    {formatMessage({ id: 'dashboardCourse.columnsPersonal.deadline', defaultMessage: 'Deadline' })}
                  </Th>         
                </Tr>
              </Thead>
              <Tbody>
                 {data?.map((survey: any) => (
                  <Tr key={survey.id}>
                    <Td>{survey?.title}</Td>         
                     <Td style={{ textAlign: 'center', fontSize: '0.85rem' }}>{survey?.started_at}</Td>
                     <Td style={{ textAlign: 'center', fontSize: '0.85rem' }}>{survey.progress_status  == 'completed' ? 
                      formatMessage({ id: 'dashboardCourse.yes', defaultMessage: 'Yes' }) :
                      formatMessage({ id: 'dashboardCourse.no', defaultMessage: 'No' })}</Td>
                    <Td style={{ textAlign: 'center', fontSize: '0.85rem' }}>{survey?.get_completed_quiz_attempts || '0'}</Td>
                    <Td style={{ textAlign: 'center', fontSize: '0.85rem' }}>{survey?.date_complete}</Td>
                    <Td style={{ textAlign: 'center', fontSize: '0.85rem' }}>{survey?.expired_at}</Td>
                  </Tr>
                ))} 
              </Tbody>
            </Table>          
            </ListContainer>
          </div>
        );
};

export default SurveyList;
